import React, { useState, useRef, useEffect } from 'react';
import mainPhoto from '../images/photo.jpg';
import { TbPlayerTrackPrevFilled, TbPlayerSkipBackFilled, TbPlayerSkipForwardFilled, TbPlayerTrackNextFilled } from 'react-icons/tb';
import { BsPlayCircle, BsStopCircle } from 'react-icons/bs';
import { GoHeartFill } from 'react-icons/go';
import myMusic from '../media/taeyeon_poem.mp3';
import { COUPLE, WEDDING_DATE, VENUE } from '../constants/wedding';

function Cover() {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(new Audio(myMusic));

  const togglePlay = () => {
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    const audio = audioRef.current;
    isPlaying ? audio.play() : audio.pause();

    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
  }, [isPlaying]);

  return (
    <div className="container">
      <img className="cover__main-photo" src={mainPhoto} alt='weddingcouple'></img>
      <div className='cover__person'>
        <div>{COUPLE.groomName}</div>
        <GoHeartFill className='cover__icon-heart' size="0.8em"/>
        <div>{COUPLE.brideName}</div>
      </div>
      <div className='cover__date'>{WEDDING_DATE.coverDisplay}</div>
      <div className='cover__place'>{VENUE.name}</div>
      <div className='cover__icon-box'>
        <TbPlayerTrackPrevFilled size="1.5em"/>
        <TbPlayerSkipBackFilled size="1.5em"/>
        {isPlaying ? (
          <BsStopCircle size="3em" className='cover__music-btn' onClick={togglePlay} aria-label="Stop Music"/>
        ) : (
          <BsPlayCircle size="3em" className='cover__music-btn' onClick={togglePlay} aria-label="Play Music"/>
        )}
        <TbPlayerSkipForwardFilled size="1.5em"/>
        <TbPlayerTrackNextFilled size="1.5em"/>
      </div>
    </div>
  );
}

export default Cover;
